import { gql } from '@apollo/client';

export type GetCSVFileRowsAllColumnsType = {
  rows: {
    id: string;
    createdAt: string;
    updatedAt: string;
    index: number;
    values: string[];
  }[];
};

export const GET_CSVFILE_ROWS_ALLCOLUMNS = gql`
  query GetCSVFileRowsAllColumns($input: CSVFileInput!) {
    rows: getCSVFileRowsAllColumns(input: $input) {
      id
      createdAt
      updatedAt
      index
      values
    }
  }
`;
